import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, mapProps } from 'recompose'
import { connect } from 'react-redux'
import * as R from 'ramda'

import DisplayConnector from 'components/form/notebookDisplayConnector/index'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import displayConnectorReducer from './reducer'
import injectReducer from 'helpers/injectReducer'
import {
  getValuesSelector,
  default as getSelectors
} from './selectors'
import {
  updateLinkTypeValue,
  updateConnectorLocationValue,
  updateConnectorSourceValue,
  updateConnectorFeatureValue,
  updateConnectorTypeValue,
  addDisplayConnector,
  removeDisplayConnector,
} from './actions'
import {
  getPath,
  combinePath
} from 'containers/Form/util'
import withValidation from './sagas'
import rules from './validations'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const reducer = createNamedReducer(valuePath, displayConnectorReducer)

  return injectReducer(valuePath, reducer)
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const updateLinkTypeAction = createNamedAction(valuePath, updateLinkTypeValue)
  const updateLocationAction = createNamedAction(valuePath, updateConnectorLocationValue)
  const updateFeatureAction = createNamedAction(valuePath, updateConnectorFeatureValue)
  const updateConnectorSourceAction = createNamedAction(valuePath, updateConnectorSourceValue)
  const updateConnectorTypeAction = createNamedAction(valuePath, updateConnectorTypeValue)
  const addDisplayConnectorAction = createNamedAction(valuePath, addDisplayConnector)
  const removeDisplayConnectorAction = createNamedAction(valuePath, removeDisplayConnector)

  const {
    valuesSelector,
    labelSelector,
    linkSourceSelector,
    locationSourceSelector,
    connectorSourceSelector,
    connectorTypeSourceSelector,
    featureSourceSelector,
  } = getSelectors(combinedPath)

  const mapStateToProps = (state) => {
    return {
      values: valuesSelector(state),
      label: labelSelector(state),
      linkSource: linkSourceSelector(state),
      locationSource: locationSourceSelector(state),
      connectorSource: connectorSourceSelector(state),
      connectorTypeSource: connectorTypeSourceSelector(state),
      featureSource: featureSourceSelector(state),
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      onLinkTypeChange: (index, value) => dispatch(updateLinkTypeAction(index, value)),
      onLocationChange: (index, value) => dispatch(updateLocationAction(index, value)),
      onFeatureChange: (index, value) => dispatch(updateFeatureAction(index, value)),
      onConnectorTypeChange: (index, value) => dispatch(updateConnectorTypeAction(index, value)),
      onConnectorChange: (index, value) => dispatch(updateConnectorSourceAction(index, value)),
      onRemove: (index) => dispatch(removeDisplayConnectorAction(index)),
      onAdd: () => dispatch(addDisplayConnectorAction()),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

export { default as DisplayConnector } from 'components/form/notebookDisplayConnector/index'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  mapProps((props) => ({ ...props, rules })),
  withReducer(path, id),
  withConnect(path, id),
  withValidation(path, id, getValuesSelector(path, id))
)(DisplayConnector))
